import { render, staticRenderFns } from "./RefundPolicyPage.vue?vue&type=template&id=622a7abc"
import script from "./RefundPolicyPage.vue?vue&type=script&lang=js"
export * from "./RefundPolicyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports